var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"color":"grey lighten-2","width":"100%","flat":"","tile":""}},[_c('v-card-text',[_c('v-row',{staticClass:"justify-center"},[_c('a',{attrs:{"href":"http://www.quixada.ufc.br","target":"_blank"}},[_vm._v("Universidade Federal do Ceará - Campus Quixadá ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }